import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-photo-tooltips',
    templateUrl: './photo-tooltips.component.html',
})
export class PhotoTooltipsComponent implements OnInit {
    @Input() name;

    constructor() {
    }

    ngOnInit() {
    }

    tooltip(tooltip, $event) {
        $event.stopPropagation();
        if (tooltip.isOpen()) {
            tooltip.close();
        } else {
            tooltip.open();
        }
    }
}
